import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import TableClasses from "Components/TableLoad";

import { FiPlus } from "react-icons/fi";
import { IoPencil } from "react-icons/io5";
import { MdDelete } from "react-icons/md";
import ReactPaginate from "react-paginate";
import { useSearchParams } from "react-router-dom";
import ImagePreview from "Components/ImagePreview";
import Moment from "react-moment";
import {
    showErrorAlert,
    showWarningAlert,
    confirmAction,
    Toast,
} from "Util/Alerts";

import { ProductsType } from "./Types";

import {
    Get_Products,
    Delete_Products,
    searchProduct,
} from "Services/Requests";
// import {  } from "Util/Alerts";
import Styles from "Styles/Styles.module.css";

function ProductsComp() {
    const Navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedTerm, setDebouncedTerm] = useState("");
    const [searchParams, setSearchParams] = useSearchParams();
    let TableHead = [
        "SKU",
        "PRODUCT",
        "CATEGORY",
        "PRICE",
        "AVAILABLE STOCK",
        "STATUS",
        "ACTIONS",
    ];
    const [Products, setProducts] = useState<ProductsType[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    // State to handle modal visibility and the selected image
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [Count, setCount] = useState(0);
    const [forcepage, setfocrcepage] = useState(0);
    const [showPaginate, setShowPaginate] = useState(false);
    const getProducts = async (page: any) => {
        try {
            const response = await Get_Products(page);
            if (response?.data?.status === 1) {
                setProducts(response?.data?.products);
                setCount(response?.data?.pageCount);
                if (response?.data?.pageCount > 1) {
                    setShowPaginate(true);
                }
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            console.log(err);
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    const DeleteProducts = async (id: any) => {
        setLoading(true);
        try {
            const response = await Delete_Products(id);
            if (response?.data?.status === 1) {
                Toast("Products Deleted Successfully", "success");
                if (searchTerm.length > 0) {
                    setSearchTerm("");
                } else {
                    getProducts(1);
                }
            } else {
                setLoading(false);
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            setLoading(false);
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        }
    };

    useEffect(() => {
        if (debouncedTerm) {
            searchProductApi();
        } else {
            let page = searchParams.get("page") ?? 1;

            setSearchParams({
                page: page.toString(),
            });

            setfocrcepage(Number(page) - 1);
            getProducts(page);
        }
    }, [debouncedTerm]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedTerm(searchTerm);
        }, 500); // Debounce delay of 500ms

        return () => clearTimeout(timer); // Cleanup function to clear timeout
    }, [searchTerm]);
    const searchProductApi = async () => {
        setLoading(true);
        try {
            const response = await searchProduct({
                search_term: debouncedTerm,
            });
            if (response?.data?.status === 1) {
                setfocrcepage(0);
                setSearchParams({ page: "1" });
                setShowPaginate(false);
                setProducts(response?.data?.data);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            console.log(err);
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setLoading(false);
        }
    };
    // Function to close the modal
    const handleCancel = () => {
        setIsModalVisible(false);
        setSelectedImage(null);
    };

    const deleteHandler = (item: ProductsType) => {
        confirmAction(
            "Warning",
            "Are you sure you want to Delete Products?",
            () => DeleteProducts(item.product_id),
            "Delete"
        );
    };
    const handlePageChange = (selectedObject: any) => {
        console.log(selectedObject);
        // setcurrentPage(selectedObject.selected);
        // handleFetch();
        setSearchParams({
            page: selectedObject.selected + 1,
        });
        setfocrcepage(selectedObject.selected);
        getProducts(selectedObject.selected + 1);
        window.scrollTo({ top: 10, behavior: "smooth" });
    };
    return (
        <div className={Styles["Container"]}>
            <ImagePreview
                handleCancel={handleCancel}
                isModalVisible={isModalVisible}
                selectedImage={selectedImage}
                title="Products"
            />
            <header>
                <h3>Products</h3>
                <button
                    className={Styles["Add_cat_btn"]}
                    onClick={() => Navigate("/auth/Products/add")}>
                    <FiPlus />
                    Add Products
                </button>
            </header>
            <div className={Styles["search"]}>
                <input
                    type="text"
                    placeholder="Search by Product or SKU "
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
            {loading ? (
                <TableClasses TableHead={TableHead} />
            ) : (
                <div className={Styles["tableWrapper"]}>
                    <table>
                        <thead>
                            {TableHead.map((item) => (
                                <th>{item}</th>
                            ))}
                        </thead>
                        <tbody>
                            {Products.length > 0 ? (
                                Products?.map((item) => (
                                    <tr key={item?.product_id}>
                                        <td>{item?.sku}</td>
                                        <td style={{ maxWidth: "10rem" }}>
                                            {item.product_name}
                                        </td>{" "}
                                        <td>{item.category_name}</td>
                                        <td>₹ {item.product_price}</td>
                                        <td>{item.available_stock}</td>
                                        <td>
                                            {item.status == 1 ? (
                                                <span
                                                    className={
                                                        Styles["Active"]
                                                    }>
                                                    Active
                                                </span>
                                            ) : (
                                                <span
                                                    className={
                                                        Styles["InActive"]
                                                    }>
                                                    InActive
                                                </span>
                                            )}
                                        </td>
                                        <td>
                                            <div
                                                className={
                                                    Styles["Action_Tabs"]
                                                }>
                                                <button
                                                    onClick={() =>
                                                        Navigate(
                                                            "/auth/Products/edit",
                                                            { state: item }
                                                        )
                                                    }>
                                                    <IoPencil size={24} />
                                                </button>

                                                <button
                                                    onClick={() =>
                                                        deleteHandler(item)
                                                    }>
                                                    <MdDelete size={22} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={TableHead.length}>
                                        No Products Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    {showPaginate && (
                        <ReactPaginate
                            pageCount={Count}
                            // pageRange={2}
                            forcePage={forcepage}
                            marginPagesDisplayed={2}
                            onPageChange={handlePageChange}
                            breakClassName={"page-item"}
                            breakLinkClassName={"page-link"}
                            containerClassName={"pagination"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            previousLinkClassName={"page-link"}
                            nextClassName={"page-item"}
                            nextLinkClassName={"page-link"}
                            activeClassName={"active"}
                        />
                    )}
                </div>
            )}
        </div>
    );
}

export default ProductsComp;
